import React, { useState, useRef } from "react";
import { useAuth } from "../AuthContext";
import { useHistory } from "react-router-dom";
import "./style.css";

const Login = () => {
  const [pin, setPin] = useState(new Array(6).fill(""));
  const [error, setError] = useState("");
  const { login } = useAuth();
  const history = useHistory();
  const inputRefs = useRef([]);

  // Нүд бүрт бичих үед ажиллах функц
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newPin = [...pin];
    newPin[index] = element.value;
    setPin(newPin);

    // Дараагийн нүд рүү шилжих
    if (element.value !== "" && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  // Backspace дарах үед өмнөх нүд рүү шилжих
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && pin[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalPin = pin.join("");
    const result = login(finalPin);

    if (result.success) {
      history.push("/");
    } else {
      setError(result.message);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Нэвтрэх код оруулах</h2>
        <p>Багшаас нь өгсөн хувийн кодоо оруулна уу!</p>

        <form onSubmit={handleSubmit}>
          <div className="pin-input-wrapper">
            {pin.map((data, index) => (
              <input
                className="pin-box"
                key={index}
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="1"
                value={data}
                ref={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => handleChange(e.target, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onFocus={(e) => e.target.select()}
              />
            ))}
          </div>

          <button
            type="submit"
            className="continue-btn"
            disabled={pin.join("").length < 6}
          >
            Үргэлжлүүлэх
          </button>
        </form>

        {error && <div className="error-msg">{error}</div>}

        <div className="resend-text">
          Код нь болохгүй байвал багшаасаа шинэ код авна уу.
        </div>
      </div>
    </div>
  );
};

export default Login;
